import { mapGetters, mapState } from 'vuex';
//import moment from "moment";

/*

These methods are fired after a sucessful "CompleteOrder"

1. Sojern
2. Google Ads
3. Googe Analytics
4. Facebook Pixel
5. Bing Advertising

*/

export default {
	data: function() {
		return {};
	},

	computed: {
		...mapGetters(['simpleProducts']),
		...mapState(['client', 'order']),

		/*
        sojernProductsSnapshot() {
            var products = [];
            if (this.activeProductDetails && this.activeProductDetails.Activities) {
                this.activeProductDetails.Activities.forEach((activity) => {
                    var participants = 0;
                    var departureDate = false;
                    var returnDate = false;
                    var dd = moment(activity.AppointmentDate).format("YYYY/MM/DD");
                    departureDate = !departureDate || dd < departureDate ? dd : departureDate;
                    returnDate = !returnDate || dd > returnDate ? dd : returnDate;
                    // get Participant count
                    if (activity.SelectedTimes) {
                        activity.SelectedTimes.forEach((selectedTime) => {
                            selectedTime.Rates.forEach((rate) => {
                                participants = participants + rate.Participants;
                            });
                        });
                    }
                    // this.$moment(this.product.Activities[0].AppointmentDate).format("ddd, MMM D");
                    var prod = {
                        departureDate: departureDate,
                        returnDate: returnDate,
                        name: activity.Name,
                        totalParticipants: participants,
                        orderEntityKey: activity.OrderEntityKey
                    }
                    products.push(prod);
                });
            }

            return products;
        },
        */

		// Loops through order.Individual and order.Packages to create a complete list of activities on the order.
		allActivities() {
			// Initiate an array to hold the activities.
			var allActivities = [];

			// If the order is an individual activity.
			if (this.order.Individual) {
				this.order.Individual.forEach((row) => {
					if (row.Activities) {
						row.Activities.forEach((activity) => {
							allActivities.push(activity);
						});
					}
				});
			}

			// If the the order is a package.
			if (this.order.Packages) {
				this.order.Packages.forEach((row) => {
					if (row.Activities) {
						row.Activities.forEach((activity) => {
							allActivities.push(activity);
						});
					}
				});
			}

			// Return the activities array.
			return allActivities;
		},
	},

	methods: {
		mixinTest() {},

		// Fire a Sojern add-to-cart conversion. Executed on cart load.
		sojernAddProductsToCart() {
			// Verify if the client has a Sojern enabled.
			// console.log("Checking to see if client has enabled Sojern before firing an add-to-cart conversion.");
			if (this.client.EnableSojern) {
				/*

                7/3/20 - TT

                this.sojernProductsSnapshot.forEach(product => {
                    console.log("sojernAddAllToCart product: ", product);
                    this.addSojernCartPixelId({
                        departureDate: product.departureDate,
                        returnDate: product.returnDate,
                        name: product.name,
                        totalParticipants: product.quantity
                    });
                });

                */

				// Iterate through the activities in this order.
				this.allActivities.forEach((activity) => {
					// Create an object for this activity.
					this.addSojernCartPixelId({
						departureDate: activity.AppointmentDate,
						returnDate: 'N/A',
						name: activity.Name,
						totalParticipants: activity.TotalParticipants
							? activity.TotalParticipants
							: 0,
					});
				});

				// Sojern is disabled.
			} else {
				console.log('Sojern is disabled.');
			}
		},

		// This will be called from the function directly above only if Sojern is enabled.
		addSojernCartPixelId(payload) {
			// Initiate values for the transaction.
			var params = {
				vid: 'tou',
				et: 'vcart',
				vd1: payload.departureDate,
				vd2: payload.returnDate,
				vf1: this.client.City,
				vs1: this.client.State,
				vn1: this.client.CountryCode,
				vb: payload.name,
				t: payload.totalParticipants,
			};

			// Initiate Sojourn library.
			var cid = [];
			var paramsArr = [];
			var cidParams = [];
			var pl = document.createElement('script');
			for (let key in cidParams) {
				cid.push(params[cidParams[key]]);
			}
			params.cid = cid.join('|');
			const keys = Object.keys(params);
			for (let key of keys) {
				paramsArr.push(key + '=' + encodeURIComponent(params[key]));
			}
			pl.type = 'text/javascript';
			pl.async = true;
			pl.src =
				'https://beacon.sojern.com/pixel/p/' +
				this.client.SojernCartPixelId +
				'?f_v=v6_js&p_v=1&' +
				paramsArr.join('&');
			(
				document.getElementsByTagName('head')[0] ||
				document.getElementsByTagName('body')[0]
			).appendChild(pl);
		},

		// Fire a Sojern purchase conversion. Executed on order completion.
		sendSojernConversion() {
			/*

            7/3/20 - TT

            this.simpleProducts.products.forEach(product => {
                this.addSojernConversionPixelId({
                    departureDate: product.AppointmentDate,
                    returnDate: product.returnDate,
                    name: product.Name,
                    totalParticipants: product.TotalParticipants,
                    price: product.SubTotal
                });
            });

            */

			// Verify if the client has a Sojern enabled.
			if (this.client.EnableSojern) {
				// Iterate through the activities in this order.
				this.allActivities.forEach((activity) => {
					// Create an object for this activity.
					this.addSojernConversionPixelId({
						departureDate: activity.AppointmentDate,
						returnDate: 'N/A',
						name: activity.Name,
						totalParticipants: activity.TotalParticipants
							? activity.TotalParticipants
							: 0,
						price: activity.SubTotal,
					});
				});

				// Sojern is disabled.
			} else {
				console.log('Sojern is disabled.');
			}
		},

		// This will be called from the function directly above only if Sojern is enabled.
		addSojernConversionPixelId(payload) {
			// Initiate values for the transaction.
			var params = {
				vid: 'tou',
				et: 'vcart',
				vd1: payload.departureDate,
				vd2: payload.returnDate,
				vf1: this.client.City,
				vs1: this.client.State,
				vn1: this.client.CountryCode,
				vb: payload.name,
				t: payload.totalParticipants,
				vp: payload.price,
				vcu: this.client.SquareCurrencyCode
					? this.client.SquareCurrencyCode
					: 'N/A',
				vconfno: this.order.OrderNumber,
			};

			// Initiate Sojourn library.
			var cid = [];
			var paramsArr = [];
			var cidParams = [];
			var pl = document.createElement('script');
			for (let key in cidParams) {
				cid.push(params[cidParams[key]]);
			}
			params.cid = cid.join('|');
			const keys = Object.keys(params);
			for (let key of keys) {
				paramsArr.push(key + '=' + encodeURIComponent(params[key]));
			}
			pl.type = 'text/javascript';
			pl.async = true;
			pl.src =
				'https://beacon.sojern.com/pixel/p/' +
				this.client.SojernConversionPixelId +
				'?f_v=v6_js&p_v=1&' +
				paramsArr.join('&');
			(
				document.getElementsByTagName('head')[0] ||
				document.getElementsByTagName('body')[0]
			).appendChild(pl);
		},

		// Fire a Google Ads purchase conversion. Executed on order completion.
		sendGoogleAdwords() {
			// Verify if the client has a the necessary values set.
			if (
				this.client.EnableGoogleAdConversions &&
				this.client.GoogleAdConversionId &&
				this.client.GoogleAdConversionLabelId
			) {
				// Make sure the GoogleAdConversionId has the correct syntax.
				if (this.client.GoogleAdConversionId.toUpperCase().includes('AW-')) {
					var send_to_value =
						this.client.GoogleAdConversionId +
						'/' +
						this.client.GoogleAdConversionLabelId;
				} else {
					var send_to_value =
						'AW-' +
						this.client.GoogleAdConversionId +
						'/' +
						this.client.GoogleAdConversionLabelId;
				}

				// Load the object.
				var ga_object = {
					send_to: send_to_value,
					value: this.order.SubTotal,
					currency: this.client.SquareCurrencyCode
						? this.client.SquareCurrencyCode
						: 'N/A',
					transaction_id: this.order.OrderNumber,
				};

				// Execute the Google Adwords conversion.
				gtag('event', 'conversion', ga_object);

				// Google Ads is disabled.
			} else {
				console.log('Google Ads is disabled.');
			}
		},

		// Fire a Google Analytics purchase conversion. Executed on order completion.
		sendGoogleAnalytics() {
			// Verify if the client has a GATrackingId set.
			if (this.client.GATrackingId || window.GA4TrackingId) {
				// Determine what this order consists of.
				var containsIndividualActivities = this.order.Individual.length > 0;
				var containsPackages = this.order.Packages.length > 0;
				var mixedOrder = containsIndividualActivities && containsPackages;
				let gcOrder = this.order.GiftCards.length > 0;

				// Initiate an object for the Google Analytics event.
				var ga_object = {
					event_category: 'N/A',
					transaction_id: this.order.OrderNumber,
					affiliation: this.client.Name,
					value: this.order.SubTotal,
					currency: this.client.SquareCurrencyCode
						? this.client.SquareCurrencyCode
						: 'N/A',
					tax: this.order.TaxTotal,
					shipping: 0,
					items: [],
				};

				// Classify the order.
				if (mixedOrder) {
					ga_object['event_category'] = 'Mixed (Activity + Package)';
				} else if (containsIndividualActivities) {
					ga_object['event_category'] = 'Activity';
				} else if (containsPackages) {
					ga_object['event_category'] = 'Package';
				}

				// If the order is either mixed or contains individual activities.
				if (mixedOrder || containsIndividualActivities) {
					// Iterate through the items in this.order.Individual
					for (var i = 0; i < this.order.Individual.length; i++) {
						// Iterate through the items in this.order.Individual[].Activities
						for (
							var j = 0;
							j < this.order.Individual[i].Activities.length;
							j++
						) {
							// Iterate through the items in this.order.Individual[].Activities[].SelectedTimes[]
							for (
								var k = 0;
								k < this.order.Individual[i].Activities[j].SelectedTimes.length;
								k++
							) {
								// Iterate through the items in this.order.Individual[].Activities[].SelectedTimes[].Rates[]
								for (
									var l = 0;
									l <
									this.order.Individual[i].Activities[j].SelectedTimes[k].Rates
										.length;
									l++
								) {
									// If participants exists for this rate.
									if (
										this.order.Individual[i].Activities[j].SelectedTimes[k]
											.Rates[l].Participants > 0
									) {
										// Add the item to the order.
										ga_object['items'].push({
											id: this.order.OrderNumber,
											category: 'Activity',
											name:
												this.order.Individual[i].Activities[j].Name +
												' – ' +
												this.order.Individual[i].Activities[j].SelectedTimes[k]
													.Rates[l].Name,
											price: this.order.Individual[i].Activities[j]
												.SelectedTimes[k].Rates[l].Price,
											quantity: this.order.Individual[i].Activities[j]
												.SelectedTimes[k].Rates[l].Participants,
										});
									}
								}
							}
						}
					}
				}

				if (gcOrder) {
					this.order.GiftCards.forEach((gc) => {
						ga_object['items'].push({
							id: this.order.OrderNumber,
							category: 'Gift Card',
							name: gc.IsSimpleProduct
								? `${gc.SubTotal} Gift Card`
								: `${gc.ProductName}`,
							price: gc.SubTotal,
							quantity: 1,
						});
					});
				}

				// If the order is either mixed or contains packages.
				if (mixedOrder || containsPackages) {
					// Iterate through the items in this.order.Packages
					for (i = 0; i < this.order.Packages.length; i++) {
						// Iterate through the items in this.order.Packages[].Activities
						for (j = 0; j < this.order.Packages[i].Activities.length; j++) {
							// Iterate through the items in this.order.Packages[].Activities[].SelectedTimes[]
							for (
								k = 0;
								k < this.order.Packages[i].Activities[j].SelectedTimes.length;
								k++
							) {
								// Iterate through the items in this.order.Packages[].Activities[].SelectedTimes[].Rates[]
								for (
									l = 0;
									l <
									this.order.Packages[i].Activities[j].SelectedTimes[k].Rates
										.length;
									l++
								) {
									// If participants exists for this rate.
									if (
										this.order.Packages[i].Activities[j].SelectedTimes[k].Rates[
											l
										].Participants > 0
									) {
										// Add the item to the order.
										ga_object['items'].push({
											id: this.order.OrderNumber,
											category: 'Package',
											name:
												this.order.Packages[i].Activities[j].Name +
												' – ' +
												this.order.Packages[i].Activities[j].SelectedTimes[k]
													.Rates[l].Name,
											price: this.order.Packages[i].Activities[j].SelectedTimes[
												k
											].Rates[l].Price,
											quantity: this.order.Packages[i].Activities[j]
												.SelectedTimes[k].Rates[l].Participants,
										});
									}
								}
							}
						}
					}
				}

				console.log('[GoogleAnalytics]', ga_object);

				// Execute the Google Analytics E-Commerce transaction.
				gtag('event', 'purchase', ga_object);

				// No value for GATrackingId.
			} else {
				console.log('GATrackingId (Google Analytics) is not set.');
			}
		},

		// Fire a Facebook purchase conversion. Executed on order completion.
		sendFaceBookPixel() {
			// Verify if the client has a FacebookPixelId set.
			if (this.client.FacebookPixelId) {
				// Inject the FB Pixel code.
				!(function(f, b, e, v, n, t, s) {
					if (f.fbq) return;
					n = f.fbq = function() {
						n.callMethod
							? n.callMethod.apply(n, arguments)
							: n.queue.push(arguments);
					};
					if (!f._fbq) f._fbq = n;
					n.push = n;
					n.loaded = !0;
					n.version = '2.0';
					n.queue = [];
					t = b.createElement(e);
					t.async = !0;
					t.src = v;
					s = b.getElementsByTagName(e)[0];
					s.parentNode.insertBefore(t, s);
				})(
					window,
					document,
					'script',
					'https://connect.facebook.net/en_US/fbevents.js'
				);

				// Initiate the Facebook Pixel.
				fbq('init', this.client.FacebookPixelId);

				// Send a page view.
				fbq('track', 'PageView');

				// Initiate an object for the Facebook conversion event.
				var fb_object = {
					transaction_id: this.order.OrderNumber,
					affiliation: this.client.Name,
					value: this.order.SubTotal,
					currency: this.client.SquareCurrencyCode
						? this.client.SquareCurrencyCode
						: 'N/A',
					tax: this.order.TaxTotal,
					shipping: 0,
					content_type: 'product',
					contents: [],
				};

				// Iterate through the activities in this order.
				this.allActivities.forEach((activity) => {
					// Add the item to the order.
					fb_object['contents'].push({
						id: activity.Name,
						quantity: activity.TotalParticipants
							? activity.TotalParticipants
							: 0,
					});
				});

				// Create the transaction.
				fbq('track', 'Purchase', fb_object);
				console.log('Facebook tracking pixel called', fb_object);

				// No value for FacebookPixelId.
			} else {
				console.log('FacebookPixelId is not set.');
			}
		}, // sendFaceBookPixel

		// Fire a Bing purchase conversion. Executed on order completion.
		sendBingEvent() {
			// Verify if the client has a sendBingEvent set.
			if (this.client.BingMarketingId) {
				// this.client.BingMarketingId has a scoping issue in the in the Bing embed code.
				var __BingMarketingId__ = this.client.BingMarketingId;

				// Inject the Bing tracking code.
				(function(w, d, t, r, u) {
					var f, n, i;
					(w[u] = w[u] || []),
						(f = function() {
							var o = { ti: __BingMarketingId__ };
							(o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
						}),
						(n = d.createElement(t)),
						(n.src = r),
						(n.async = 1),
						(n.onload = n.onreadystatechange = function() {
							var s = this.readyState;
							(s && s !== 'loaded' && s !== 'complete') ||
								(f(), (n.onload = n.onreadystatechange = null));
						}),
						(i = d.getElementsByTagName(t)[0]),
						i.parentNode.insertBefore(n, i);
				})(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');

				// Add the revenue for this event.
				window.uetq = window.uetq || [];
				window.uetq.push('event', {
					revenue_value: this.order.SubTotal,
					currency: this.client.SquareCurrencyCode
						? this.client.SquareCurrencyCode
						: 'N/A',
				});

				// No value for FacebookPixelId.
			} else {
				console.log('BingMarketingId is not set.');
			}
		},
	},
};
